import { first, last } from 'lodash';

import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToInteger from 'utils/converters/fromAnyToInteger';
import withOptions from 'utils/functions/withOptions.util';
import isDigit from 'utils/predicates/number/isDigit.util';

const parseDigit = withOptions(({ value: raw, position }) => {
  const empty = raw === '' || raw === null || raw === void 1;

  if (empty) return { number: NaN, string: '', raw, is: { empty: true, valid: false } };

  const takeOne = position === 'first' ? first : last;
  const chars = [...fromAnyToTrimmed(raw)];
  const char = takeOne(chars);

  const number = Math.abs(fromAnyToInteger(char));
  const valid = isDigit(number);

  const is = { empty, valid };

  return { number, string: valid ? `${number}` : '', is, raw };
});

export default parseDigit;
